import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import WrapperOrders from "../../../components/shared/WrapperContent";
import OrdersContent from "../../../components/orders/content";
import style from "./OrdersAvailable.module.scss";
import cn from "classnames";
import DefaultPagination from "../../../components/shared/DefaultPagination";
import { Order, User } from "../../../services";
import Loading from "../../../components/shared/Loading/Loading";
import EmptyContent from "../../../components/shared/emptyContent";
import { useSelector } from "react-redux";
import OrdersTable from "../../../components/orders-new/available/components/OrdersTable";
import HeaderContentNew from "../../../components/shared/HeaderContentNew/HeaderContentNew";
import { EXPEDITOR_TABS } from "../../../mock";

const ITEMS_LIMIT = 10;

const OrdersAvailablePage = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const { user } = useSelector((state) => state);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersTotal, setOrdersTotal] = useState(0);

  const [isActiveTabTender, setIsActiveTabTender] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);

  const [activeTap, setActiveTap] = useState("all");
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [orderCounts, setOrderCounts] = useState({});

  const updateActiveStatus = (item, statuses) => {
    setActiveTap(item.key);
    setActiveStatuses(statuses);
    getOrders(statuses, item.key);
  };

  const getOrderCounts = () => {
    const statusGroups = EXPEDITOR_TABS(t).map((tab) => ({
      key: tab.key,
      status: tab.statuses,
    }));

    Order.getStatusWithOrderCountsForExpeditor({ statusGroups })
      .then((response) => {
        const data = response.data;
        const counts = data.reduce((acc, item) => {
          acc[item.key] = item.count;
          return acc;
        }, {});
        setOrderCounts(counts);
      })
      .catch((error) => {
        console.error(t('ordersAvailable.errors.fetchCountsError'), error);
      });
  };

  const getOrderProps = (key) => {
    return {
      isShowOrderDecision: key === "all",
      isSuggestPrice: key === "tender",
      isShowOrderDecision: key === "awaitingExpeditor",
      isAssignDriver: key === "published",
      isShowOrderDecision: key === "unloadingCargo",
    };
  };

  const getOrders = (statuses = [], key = "") => {
    setLoading(true);

    const data = {
      page: currentPage,
      limit: ITEMS_LIMIT,
      statuses: statuses,
      orderNo: "",
    };

    key === "tender"
      ? Order.getTenderOrderList(currentPage, ITEMS_LIMIT)
          .then((res) => res.data)
          .then((response) => {
            setOrders(response.rows);
            setOrdersTotal(response.total);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => setLoading(false))
      : Order.getOrderListForExpeditor(data)
          .then((res) => res.data)
          .then((response) => {
            setOrders(response.rows);
            setOrdersTotal(response.total);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => setLoading(false));
  };

  const currentOrderProps = useMemo(() => getOrderProps(activeTap), [activeTap]);

  useEffect(() => {
    getOrderCounts();
    getOrders(activeStatuses, activeTap);
  }, [currentPage, isActiveTabTender, forceUpdate, activeTap]);

  return (
    <>
      <HeaderContentNew
        title={t('ordersAvailable.pageTitle')}
        displayTitle={true}
        displayCreateBtn={false}
        displayReloadBtn={false}
      />

      <WrapperOrders>
        <div className={style.menu}>
          {EXPEDITOR_TABS(t).map((item) => (
            <button
              type="button"
              key={"desktop-" + item.key}
              className={cn(style.menu_button, "d-flex align-items-center text-nowrap", {
                [style.menu_button_active]: item.key === activeTap,
              })}
              onClick={() => updateActiveStatus(item, item.statuses)}
            >
              {t(`common.status.tabs.${item.key}`, item.title)}
              <span
                className={cn(style.count, {
                  [style.count_active]: item.key === activeTap,
                })}
              >
                {item.key === "tender" && item.key === activeTap
                  ? ordersTotal
                  : orderCounts[item.key] || 0}
              </span>
            </button>
          ))}
        </div>

        <OrdersContent>
          <div className={style.content}>
            {isLoading ? (
              <Loading inBlock />
            ) : !orders.length && !isLoading ? (
              <EmptyContent />
            ) : (
              <>
                <OrdersTable
                  items={orders || []}
                  isLoading={false}
                  companyName={user?.companyName}
                  onForceUpdate={() => {
                    setForceUpdate((prev) => prev + 1);
                  }}
                  {...currentOrderProps}
                  isShowOrderDecision
                />
              </>
            )}
          </div>

          <DefaultPagination
            currentPage={currentPage}
            limit={ITEMS_LIMIT}
            total={ordersTotal}
            changePage={setCurrentPage}
          />
        </OrdersContent>
      </WrapperOrders>
    </>
  );
};

export default OrdersAvailablePage;
